import { CreateVoucherRequest, VoucherResponse } from "../model/VoucherModel";
import { PageResponse } from "../../applications/constants/AppTypes";
import { ApiClient } from "../api/ApiClient";

const BASE_URL = "/api/vouchers";
class VoucherServiceClass {
  getAllVoucher(page: number, limit: number, is_active?: boolean) {
    return ApiClient.get<PageResponse<VoucherResponse[]>>(BASE_URL + "/all", {
      params: {
        page,
        limit,
        is_active,
      },
    });
  }

  createVoucher(request: CreateVoucherRequest) {
    return ApiClient.post<VoucherResponse[]>(BASE_URL + "/add", request);
  }

  updateVoucher(id: number, request: CreateVoucherRequest) {
    return ApiClient.put<VoucherResponse>(BASE_URL + `/${id}/update`, request);
  }

  deleteVoucher(id: number) {
    return ApiClient.delete(BASE_URL + `/${id}/delete`);
  }

  checkActiveVoucher(code: string) {
    return ApiClient.get<VoucherResponse>(BASE_URL + `/check`, {
      params: {
        code,
      },
    });
  }
}

export const VoucherService = new VoucherServiceClass();
